<div class="bg-white p-3 mt-2">
  <div>
    <div class="left-side">
      <h2 class="m-0">Add E-Content</h2>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-5">
      <div class="row">
        <div
          *ngFor="let question of questions"
          class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
        >
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
      <!-- File Upload Field -->
      <div class="mb-3">
        <label class="d-block mb-2 fw-semibold">Upload Document or Image</label>
        <button
          mat-raised-button
          color="accent"
          type="button"
          (click)="fileInput.click(); $event.stopPropagation()"
        >
          Select File
        </button>
        <input
          #fileInput
          type="file"
          (change)="onFileSelected($event)"
          (click)="$event.stopPropagation()"
          hidden
          accept="image/*,application/pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
        />

        <div *ngIf="filePreview && isImage" class="mt-2">
          <img
            [src]="filePreview"
            alt="Preview"
            style="max-width: 180px; max-height: 120px; border-radius: 4px"
          />
        </div>

        <div *ngIf="fileName && !isImage" class="mt-2">
          <mat-icon>insert_drive_file</mat-icon>
          <span>{{ fileName }}</span>
        </div>
      </div>

      <!-- Buttons -->
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!form.valid"
      >
        Submit
      </button>
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
    </form>
  </div>
</div>
